export const CONTACT_FIRST_NAME_ID = 'shipping-contact-first-name';
export const CONTACT_LAST_NAME_ID = 'shipping-contact-last-name';
export const CONTACT_EMAIL_ID = 'shipping-contact-email';
export const CONTACT_EMAIL_CONFIRMATION_ID = 'shipping-contact-confirm-email';
export const CONTACT_PHONE_COUNTRY_ID = 'shipping-contact-phone-country';
export const CONTACT_PHONE_AREA_ID = 'shipping-contact-phone-area';
export const CONTACT_PHONE_NUMBER_ID = 'shipping-contact-phone-number';
export const CONTACT_PHONE_EXTENSION_ID = 'shipping-contact-phone-extension';
